import { style } from '@vanilla-extract/css';

import columnStyles from '../columnElement/Column.css';
import rootStyles from '../rootElement/Root.css';

const { columnItemElement } = columnStyles;
const { rootElement } = rootStyles;

export const codeBlockElement = style({
  position: 'relative',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  margin: 'var(--margin)',
  selectors: {
    [`${rootElement} > &`]: {
      paddingLeft: 30,
      paddingRight: 30,
    },
    [`${columnItemElement} > &`]: {
      width: 'calc(100% - var(--margin-left) - var(--margin-right))',
      maxWidth: 'calc(100% - var(--margin-left) - var(--margin-right))',
    },
  },
});

export const code = style({
  WebkitFontSmoothing: 'auto',
  fontFamily: 'monospace',
});

export const pre = style({
  margin: '0',
  lineHeight: 'normal',
  overflowX: 'auto',
  padding: '1.25em 1.5em',
  whiteSpace: 'pre',
  wordWrap: 'normal',
  backgroundColor: 'var(--background-button)',
  boxShadow: 'var(--box-shadow)',
  borderRadius: 'var(--border-radius)',
  WebkitFontSmoothing: 'auto',
  fontFamily: 'monospace',
});
